import { ContentType } from '@/components/layout/section/SectionBaseModel';
import { goToFictiveFlowPage } from '@/utilities/Flow';
import store from '@/store';
import { SdkFlowPageModel } from '@/sdk/models/flowPage';

export class SdkFlowpageApi {
  public static showMessage(title: string, description: string) {
    goToFictiveFlowPage(title, {
      type: ContentType.TEXT,

      content: description
    });
  }

  public static async getAll(): Promise<SdkFlowPageModel[]> {
    await store.getters['campaign/readyPromise'];

    return store.getters['campaign/model'].state.flowPages.map((flowPage) => {
      return new SdkFlowPageModel(flowPage);
    });
  }

  public static async makeActive(id: number): Promise<void> {
    await store.getters['campaign/readyPromise'];

    const flowPage = store.getters['campaign/model'].state.flowPages.find((flowPage) => flowPage.state.id === id);

    if (!flowPage) {
      throw new Error('Unrecognized flow page id. Not found in collection');
    }

    if (
      flowPage.state.config.settings.state.advanced.visibilityCondition &&
      !flowPage.state.config.settings.state.advanced.visibilityCondition?.check()
    ) {
      throw new Error('Cannot go to flow page that user is not allowed to see (visibility conditions)');
    }

    store.commit('campaign/setCurrentFlowId', id);
  }
}
